import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ChevronRightSvg } from '../../assets/svgs';
import { Card, CardIcon, CardLabel, CardRow, CardValue, CardWrapper, StyledTable, StyledTd, StyledTh, StyledThead, StyledTr, TableWrapper } from './table.style';

const defaultProps = {
  rows: [
    { id: 1, header1: 'Dummy text A', header2: 'Dummy text B', header3: 'Dummy text C' },
    { id: 2, header1: 'Dummy text X', header2: 'Dummy text Y', header3: 'Dummy text Z' },
    { id: 3, header1: 'Dummy text M', header2: 'Dummy text N', header3: 'Dummy text O' },
  ],
  columns: [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'header1', headerName: 'Header 1', width: 120 },
    { field: 'header2', headerName: 'Header 2', width: 120 },
    { field: 'header3', headerName: 'Header 3', width: 120 },
  ],
};

const TableComponent = ({ columns = defaultProps.columns, rows = defaultProps.rows, icon: Icon, responsive = true }) => {
  const initialSortConfig = { field: null, direction: 'asc' };
  const [sortConfig, setSortConfig] = useState(initialSortConfig);
  const [sortedRows, setSortedRows] = useState(rows);
  const [scrollTop, setScrollTop] = useState(0);

  const handleScroll = (e) => {
    setScrollTop((document?.getElementsByTagName('thead')[0]?.offsetTop) || 0);
  };

  const handleSort = (column) => {
    if (column?.sortable === false) return;

    const newDirection = sortConfig.field === column?.field && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({ field: column?.field, direction: newDirection });

    const sortedData = [...rows].sort((a, b) => {
      const valueA = column.valueGetter ? column.sortBy ? column.sortBy(a) : column.valueGetter(a) : a[column?.field];
      const valueB = column.valueGetter ? column.sortBy ? column.sortBy(b) : column.valueGetter(b) : b[column?.field];

      if (valueA < valueB) return newDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return newDirection === 'asc' ? 1 : -1;
      return 0;
    });

    setSortedRows(sortedData);
  };

  useEffect(() => {
    setSortConfig(initialSortConfig);
    setSortedRows(rows);
  }, [rows]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TableWrapper className='box-shadow custom-scrollbar' onScroll={handleScroll}>
      <StyledTable $responsive={responsive}>
        <StyledThead $offsettop={scrollTop}>
          <tr>
            {
              columns && columns.map((column, index) => (
                <StyledTh
                  key={index}
                  $minwidth={column.width || 100}
                  $align={column.align}
                  onClick={() => handleSort(column)}
                  $sortdirection={sortConfig.field === column.field ? sortConfig.direction : null}
                  $sticky={column.sticky}
                  $action={column.field === 'action'}
                >
                  {column.headerName}
                  {sortConfig.field === column.field && <ChevronRightSvg />}
                </StyledTh>
              ))
            }
          </tr>
        </StyledThead>
        <tbody>
          {
            Array.isArray(sortedRows) && sortedRows?.map((row, index) => (
              <StyledTr key={row.id || index}>
                {
                  columns && columns.map((column) => (
                    <StyledTd key={column.field} $align={column.align} $sticky={column.sticky} $zindex={(sortedRows.length - index)} $action={column.field === 'action'}>
                      {column.valueGetter ? column.valueGetter(row) : row[column.field]}
                    </StyledTd>
                  ))
                }
              </StyledTr>
            ))
          }
        </tbody>
      </StyledTable>

      {
        responsive &&
        <CardWrapper>
          {
            sortedRows && sortedRows.map((row, rowIndex) => (
              <Card key={row.id || rowIndex} className='box-shadow'>
                {/* Show action column first */}
                {
                  columns && columns.map((column, colIndex) => (
                    (column.field === 'action') &&
                    <CardRow key={colIndex}>
                      <CardLabel>
                        {
                          Icon &&
                          <CardIcon className='box-shadow'>
                            <Icon />
                          </CardIcon>
                        }
                      </CardLabel>
                      <CardValue>
                        {column.valueGetter ? column.valueGetter(row) : row[column.field]}
                      </CardValue>
                    </CardRow>
                  ))
                }
                {/* Show other columns after action */}
                {
                  columns && columns.map((column, colIndex) => (
                    column.field !== 'action' &&
                    <CardRow key={colIndex}>
                      <CardLabel>{column.headerName}</CardLabel>
                      <CardValue>
                        {column.valueGetter ? column.valueGetter(row) : row[column.field]}
                      </CardValue>
                    </CardRow>
                  ))
                }
              </Card>
            ))
          }
        </CardWrapper>
      }
    </TableWrapper>
  );
};

TableComponent.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  icon: PropTypes.elementType,
  responsive: PropTypes.bool,
};

export default TableComponent;
